"use client";

import React from "react";
import { ArrowDown } from "lucide-react";
import { Separator } from "@/components/ui/separator";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function SystemIdentity() {
  const {
    ref: headingRef,
    isVisible: isHeadingVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: separatorRef,
    isVisible: isSeparatorVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: buttonRef,
    isVisible: isButtonVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="224011" id="contacthero" className="relative min-h-screen flex flex-col items-center justify-center bg-background text-foreground overflow-hidden py-24 px-6 sm:px-10 light">
      {}
      <style>{`
        @keyframes subtle-pulse-scale {
          0%, 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(var(--primary), 0); }
          50% { transform: scale(1.02); box-shadow: 0 0 20px 0 rgba(var(--primary), 0.1); }
        }
        .animate-subtle-pulse {
          animation: subtle-pulse-scale 4s ease-in-out infinite;
        }
      `}</style>

      {}
      <div className="absolute inset-0 z-0 pointer-events-none flex items-center justify-center">
        <div className="absolute inset-0 bg-[linear-gradient(to_right,var(--border)_1px,transparent_1px),linear-gradient(to_bottom,var(--border)_1px,transparent_1px)] bg-[size:4rem_4rem] opacity-[0.1] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_20%,transparent_100%)]"></div>
      </div>

      <div className="relative z-10 w-full max-w-5xl mx-auto flex flex-col items-center text-center">
        {}
        <div ref={headingRef} className={`transition-all duration-1000 ease-out transform ${isHeadingVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h1 className="font-default text-5xl sm:text-6xl md:text-7xl lg:text-[5.5rem] font-bold tracking-tighter leading-[1.05] text-foreground max-w-4xl mx-auto">
            Get in Touch
          </h1>
        </div>

        {}
        <div ref={separatorRef} className={`my-12 md:my-16 transition-all duration-1000 delay-300 ease-out h-24 md:h-32 flex items-center justify-center ${isSeparatorVisible ? "opacity-100 scale-y-100" : "opacity-0 scale-y-0"} origin-top`}>
          <Separator orientation="vertical" className="h-full w-[2px] bg-primary/30" />
        </div>

        {}
        <div ref={textRef} className={`transition-all duration-1000 delay-500 ease-out transform ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <p className="font-default text-lg md:text-xl text-muted-foreground leading-relaxed max-w-2xl mx-auto">
            We are here to help you streamline your academic data management. Reach out to our support team for technical assistance, system integration inquiries, or to request a personalized demonstration.
          </p>
        </div>

        {}
        <div ref={buttonRef} className={`mt-16 md:mt-20 transition-all duration-1000 delay-700 ease-out transform ${isButtonVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="animate-subtle-pulse inline-block">
            <Button asChild size="lg" className="rounded-md px-8 py-6 text-base tracking-wide uppercase font-semibold shadow-lg bg-primary text-primary-foreground hover:bg-primary/90">
              <Link to="/ContactPage">
                Contact Support
                <ArrowDown className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}